// build-tick: 2026-05-27T16:35
(function () {
class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("keyup", (evt) => evt.code === "Escape" && this.close());
    this.querySelector("#CartDrawer-Overlay").addEventListener("click", this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    this.bindUpsellButton();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble");
    if (!cartLink) return;

    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");
    cartLink.addEventListener("click", (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener("keydown", (event) => {
      const key = event.code.toUpperCase();
      if (key === "SPACE" || key === "ENTER") {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  bindUpsellButton() {
    this.addEventListener("click", (event) => {
      const upsellButton = event.target.closest(".upsell-add-button");
      if (upsellButton) {
        event.preventDefault();

        const form = upsellButton.closest(".upsell-form");
        const variantId = form.querySelector('input[name="id"]').value;

        this.addItemToCart(variantId);
      }
    });
  }

  async addItemToCart(variantId) {
    const sections = this.getSectionsToRender().map((section) => section.id);

    const body = JSON.stringify({
      id: variantId,
      quantity: 1,
      sections: sections,
      sections_url: window.location.pathname,
    });

    try {
      const response = await fetch(`${routes.cart_add_url}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: `application/json`,
        },
        body,
      });

      if (response.status === 422) {
        const errorData = await response.json();
        // Handle error (e.g., show a notification)
        console.error("Error adding item to cart:", errorData.description);
        return;
      }

      const parsedState = await response.json();
      this.renderContents(parsedState);
    } catch (error) {
      console.error("Error adding item to cart:", error);
    }
  }

  startCountdownTimer() {
    const timerElement = document.getElementById("cart-countdown-timer");
    if (!timerElement) return;

    // Reset timer to 10 minutes
    let minutes = 10;
    let seconds = 0;

    // Clear any existing timer
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }

    // Update the timer display
    const updateTimer = () => {
      timerElement.textContent = `${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
    };

    // Initial display
    updateTimer();

    // Start the countdown
    this.countdownInterval = setInterval(() => {
      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(this.countdownInterval);
          return;
        }
        minutes--;
        seconds = 59;
      } else {
        seconds--;
      }

      updateTimer();
    }, 1000);
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role")) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add("animate", "active");
    });

    this.addEventListener(
      "transitionend",
      () => {
        // Empty cart renders `cart-empty` inside `.drawer__inner` — there is no
        // `.drawer__inner-empty` element, so fall back to elements that exist to
        // avoid trapFocus(null) throwing on the empty drawer.
        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".drawer__inner-empty") ||
            this.querySelector(".drawer__inner") ||
            document.getElementById("CartDrawer")
          : document.getElementById("CartDrawer");
        const focusElement = this.querySelector(".drawer__inner") || this.querySelector(".drawer__close");
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true },
    );

    document.body.classList.add("overflow-hidden");
    /* Cart-specific flag so floating app overlays (Intercom chat bubble) can
       hide behind the open drawer — see the rule in layout/theme.liquid. */
    document.body.classList.add("cart-drawer-open");

    // Start the countdown timer when drawer opens
    this.startCountdownTimer();
  }

  close() {
    // Check if cart customization mode is active
    const cartCustomizationMode = document.querySelector("cart-drawer").classList.contains("customization-mode");
    if (cartCustomizationMode) {
      alert("Cart Customization Mode is active. Disable it in Theme Settings > Cart Drawer to allow closing.");
      return;
    }

    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
    document.body.classList.remove("cart-drawer-open");

    // Clear the countdown timer when drawer closes
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute("aria-controls", cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute("aria-expanded", !event.currentTarget.closest("details").hasAttribute("open"));
    });

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector(".drawer__inner").classList.contains("is-empty") &&
      this.querySelector(".drawer__inner").classList.remove("is-empty");
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      if (section.id == "cart-drawer" || section.selector == "#CartDrawer") {
        const newCartDrawer = this.getSectionDOM(parsedState.sections[section.id], section.selector);
        updateCartDrawer(sectionElement, newCartDrawer);
      } else {
        if (section.id === "cart-icon-bubble") {
          const iconType = sectionElement.getAttribute("data-cart-icon-type");
          sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
          if (iconType) {
            sectionElement.setAttribute("data-cart-icon-type", iconType);
          }
          const iconWrapper = sectionElement.querySelector(".svg-wrapper");
          if (iconWrapper && iconType) {
            const bagIcon = iconWrapper.querySelector(".cart-icon-bag");
            const cartIcon = iconWrapper.querySelector(".cart-icon-cart");
            const cartIconEmpty = iconWrapper.querySelector(".cart-icon-cart-empty");
            
            if (iconType === "bag") {
              if (bagIcon) bagIcon.style.display = "flex";
            } 
            else {
              const cartEmpty = parsedState.item_count === 0;
              if (cartEmpty && cartIconEmpty) {
                cartIconEmpty.style.display = "flex";
              } else if (cartIcon) {
                cartIcon.style.display = "flex";
              }
            }
          }
        } else {
          sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
        }
      }
    });

    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener("click", this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser().parseFromString(html, "text/html").querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser().parseFromString(html, "text/html").querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-drawer", CartDrawer);

// cart.js loads before cart-drawer-v2.js (both deferred), so CartItems is always
// defined by the time this executes. Guard kept as a safety check.
if (typeof CartItems !== "undefined") {
  defineCartDrawerItems();
}

function defineCartDrawerItems() {
  if (customElements.get("cart-drawer-items")) {
    return; // Already defined
  }

  class CartDrawerItems extends CartItems {
    /**
     * Override the parent's connectedCallback to use a much shorter debounce.
     *
     * The base CartItems uses ON_CHANGE_DEBOUNCE_TIMER (300ms) which was set
     * for typing protection in the qty input. But it applies to every change
     * event — including +/- button clicks that fire exactly one event per
     * press. With 300ms debounce, every single +/- click waited 300ms before
     * the network even started. That's the dominant source of perceived
     * slowness, not the network itself.
     *
     * 50ms is enough to coalesce rapid spam-clicks into one final request
     * while still feeling instant for single clicks.
     */
    connectedCallback() {
      const DRAWER_DEBOUNCE_MS = 50;
      this.boundOnChange = debounce((event) => {
        this.onChange(event);
      }, DRAWER_DEBOUNCE_MS);
      this.addEventListener("change", this.boundOnChange);

      this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (event.source === "cart-items") return;
        return this.onCartUpdate();
      });
    }

    /**
     * Override the parent's enableLoading so we don't blank out the row.
     *
     * The base implementation reveals .loading__spinner overlays inside the
     * cart item, and component-cart-items.css has:
     *   .cart-item .loading__spinner:not(.hidden) ~ * { visibility: hidden; }
     * which hides every sibling — meaning our optimistic-paint quantity
     * update is invisible during the network roundtrip. The user sees the
     * row blank out for ~500ms even though we already updated the qty.
     *
     * We keep aria + the cart__items--disabled (pointer-events:none) to
     * prevent double-clicks, but skip the spinner reveal so optimistic
     * paint is visible.
     */
    enableLoading(line) {
      // Skip the spinner reveal (hides whole row) AND the cart-wide
      // pointer-events:none. Rapid clicks need to keep registering so
      // the user can step from 1→5 without waiting between each press.
      // AbortController in updateQuantity prevents races between in-flight
      // requests — the latest click always wins.
      if (this.lineItemStatusElement) this.lineItemStatusElement.setAttribute("aria-hidden", false);
    }

    disableLoading(line) {
      // No-op — enableLoading didn't add anything visual to undo.
    }

    getSectionsToRender() {
      // Retained so legacy callers that re-render via sections still work.
      // The fast-path updateQuantity() below bypasses this and updates DOM
      // directly from the cart/change.js JSON response.
      return [
        {
          id: "CartDrawer",
          section: "cart-drawer",
          selector: ".drawer__inner",
        },
        {
          id: "cart-icon-bubble",
          section: "cart-icon-bubble",
          selector: ".shopify-section",
        },
      ];
    }

    /**
     * Fast-path quantity update — optimistic, JSON-driven, ~50ms perceived.
     *
     * Why this override exists
     * ────────────────────────
     * The inherited CartItems.updateQuantity (assets/cart.js) POSTs to
     * /cart/change.js with `sections=cart-drawer,cart-icon-bubble`. The
     * server then re-renders the entire 4,726-line cart-drawer section —
     * upsells (with all_products[] lookups), volume discount bars (iterating
     * cart.items × product.collections), free-gift logic, line items, totals.
     * That server work + the ~50KB HTML payload is the bulk of the
     * perceived latency on +/-/remove.
     *
     * Everything the user can SEE update is already in the JSON response
     * (item_count, total_price, total_discount, items[].final_line_price,
     * items[].quantity, etc.). We update the visible DOM straight from
     * that JSON; the section's Liquid render is redundant for these
     * actions.
     *
     * Fallback to the inherited section-render path triggers when:
     *  - cart became empty or non-empty (state transition needs structure)
     *  - free-product threshold crossed (free-gift add/remove logic in
     *    cart.js handleCartUpdate is non-trivial to replicate here)
     *  (discount changes — incl. BMSM/MMS tier crossings — stay on the fast
     *  path: Liquid always renders the badge/savings/strikethrough nodes and
     *  _applyJsonState toggles them from JSON)
     *  - server returned a validation error (use full path for error UI)
     *
     * Volume discount bar updates from a categorization map that Liquid
     * emits in #hcs-vdb-state on every cart-drawer render. That map is the
     * authoritative result of the 5-step cascade (collections → tags →
     * type). New products get categorized whenever the section re-renders
     * (e.g. on add-to-cart), so client-side never has to replicate the
     * cascade — it just looks up the answer.
     */
    updateQuantity(line, quantity, event, name, variantId, callbackFn, lineKey) {
      // CartRemoveButton lives inside cart.js's IIFE and isn't visible here,
      // so detect the remove button by its registered custom-element tag instead.
      const eventTarget = event?.currentTarget?.tagName === "CART-REMOVE-BUTTON" ? "clear" : "change";
      const isRemove = quantity === 0;

      // ── OPTIMISTIC UI — paint NOW, synchronously, for every click. Even when
      // the actual fetch is queued behind a prior remove, the user sees their
      // click register in the same frame (row fades, count bubble drops).
      //
      // Per-row snapshot (keyed by line-item key when present, else line index)
      // so concurrent removes don't overwrite each other's revert info. The
      // single-slot `_lastOptimistic` is kept as a fallback for legacy callers.
      const _preRow = lineKey
        ? this.querySelector(`tr.cart-item[data-key="${lineKey}"]`)
        : document.getElementById(`CartDrawer-Item-${line}`);
      const _preQtyInput = _preRow ? _preRow.querySelector("input.quantity__input") : null;
      const _preQty = _preQtyInput ? parseInt(_preQtyInput.value, 10) : null;
      const snap = { line, lineKey, oldQty: _preQty, removedRow: isRemove && _preRow };
      const snapKey = lineKey || `line-${line}`;
      this._optimisticSnaps = this._optimisticSnaps || new Map();
      this._optimisticSnaps.set(snapKey, snap);
      this._lastOptimistic = snap;

      this._optimisticPaint(line, quantity, lineKey);
      this.enableLoading(line);

      // ── Execution policy:
      //   - Quantity changes (+/-): fire immediately. Abort any prior +/-
      //     in-flight; `{line/id, quantity}` is idempotent and the latest
      //     click is canonical.
      //   - Removes: serialize via promise chain. Parallel remove responses
      //     race on totals + checkout-button text + section refetch — the
      //     last response to land overwrites UI with its (often stale)
      //     snapshot, producing doubled labels like "CHECKOUT · CHECKOUT ·
      //     $15.94" and orphaned faded rows. Serializing means responses
      //     arrive in click order; the final response reflects the final
      //     cart state. Optimistic paint (above) keeps the click feeling
      //     instant; only the fetch waits.
      if (isRemove) {
        const prior = this._removeChain || Promise.resolve();
        const next = prior.then(() =>
          this._runUpdateFetch(line, quantity, event, name, variantId, callbackFn, lineKey, snapKey, eventTarget),
        );
        // Keep the chain alive even if a remove rejected — otherwise one
        // failure blocks every subsequent trash click forever.
        this._removeChain = next.catch(() => {});
        return next;
      }

      if (this._inflightController) this._inflightController.abort();
      this._inflightController = new AbortController();
      return this._runUpdateFetch(
        line,
        quantity,
        event,
        name,
        variantId,
        callbackFn,
        lineKey,
        snapKey,
        eventTarget,
        this._inflightController.signal,
      );
    }

    /**
     * The actual fetch + JSON-apply logic, split out so removes can be
     * serialized via a promise chain while quantity changes run inline.
     */
    _runUpdateFetch(line, quantity, event, name, variantId, callbackFn, lineKey, snapKey, eventTarget, signal) {
      const oldTotalPrice =
        parseInt(document.querySelector(".cart-drawer .gb-totals-total-value")?.textContent ?? "0", 10) || 0;
      const wasEmpty = this.classList.contains("is-empty");

      // Prefer stable line-item key over 1-based index. Indices shift after
      // any remove commits server-side; with two fast trash clicks the second
      // request can otherwise hit a now-shifted line and return 422.
      // One-round-trip fallback for the predictable structural case: removing
      // a line while every other row is the hidden shipping-protection line
      // means the drawer is about to need its empty-state structure — a full
      // section render either way. Bundle it into the mutation request instead
      // of refetching after. Mis-prediction is harmless: unused bundled HTML
      // is ignored, and an unpredicted transition still uses the refetch.
      let bundleSections = false;
      if (quantity === 0) {
        bundleSections = Array.from(this.querySelectorAll("tr.cart-item")).every(
          (tr) =>
            tr.hasAttribute("data-shipping-protection") ||
            (lineKey ? tr.getAttribute("data-key") === lineKey : tr.id === `CartDrawer-Item-${line}`),
        );
      }
      const payload = lineKey ? { id: lineKey, quantity } : { line, quantity };
      if (bundleSections) {
        payload.sections = ["cart-drawer"];
        payload.sections_url = window.location.pathname;
      }
      const body = JSON.stringify(payload);

      return fetch(`${routes.cart_change_url}.js`, { ...fetchConfig(), body, signal })
        .then((response) => response.text().then((text) => ({ httpStatus: response.status, text })))
        .then(({ httpStatus, text }) => {
          let state;
          try {
            state = JSON.parse(text);
          } catch (e) {
            state = null;
          }

          // Validation failure, HTTP error (403 bot-protection HTML, 422 line
          // validation, 5xx), or unparseable body: hand off to the legacy path
          // so its error-display code (cart-errors / cartStrings.error / live
          // region) fires correctly. Revert the optimistic paint first so
          // the drawer is in a consistent state regardless of whether the
          // fallback succeeds (replacing the DOM) or fails (preserving it).
          if (!state || state.errors || state.status === 422 || httpStatus >= 400) {
            this._revertOptimisticPaint(snapKey);
            return this._fallbackToInherited(line, quantity, event, name, variantId, callbackFn, lineKey);
          }

          const isNowEmpty = state.item_count === 0;
          // Discount changes (BMSM/MMS tier crossings included) are now fully
          // rendered by _applyJsonState — badge, strikethroughs, savings line
          // are always-present DOM nodes it can toggle. No refetch needed.
          const freeProductCrossed = this._didCrossFreeProductThreshold(oldTotalPrice, state.total_price);

          // Linked-free-gifts (premium-attachment-kit): if items were removed
          // AND the cart had a linked-gift item, the inherited path's gift
          // cleanup side effects matter. Fall through to it for correctness.
          const hadItemsRemoved = (state.items_removed || []).length > 0;
          const hasLinkedGifts = (state.items || []).some(
            (it) => it.properties && it.properties._is_free_gift === "true",
          );

          if (
            wasEmpty !== isNowEmpty ||
            freeProductCrossed ||
            (hadItemsRemoved && hasLinkedGifts)
          ) {
            // Edge case — refetch just the cart-drawer section HTML and run
            // it through the existing updateCartDrawer pipeline. We skip
            // re-POSTing /cart/change.js since the mutation already happened.
            return this._refetchCartDrawerSection(state, eventTarget, event, variantId, callbackFn);
          }

          // Fast path: paint from JSON only.
          this._applyJsonState(state, line, quantity, lineKey);
          if (this._optimisticSnaps) this._optimisticSnaps.delete(snapKey);

          CartPerformance.measureFromEvent(`${eventTarget}:user-action`, event);
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: "cart-items",
            cartData: state,
            variantId: variantId,
          });
          if (typeof callbackFn === "function") callbackFn();
        })
        .catch((err) => {
          // Expected: a newer +/- click superseded this request.
          if (err && err.name === "AbortError") return;
          console.error("CartDrawerItems fast updateQuantity failed; using inherited path:", err);
          this._revertOptimisticPaint(snapKey);
          return this._fallbackToInherited(line, quantity, event, name, variantId, callbackFn, lineKey);
        })
        .finally(() => {
          this.disableLoading(line);
        });
    }

    _fallbackToInherited(line, quantity, event, name, variantId, callbackFn, lineKey) {
      // Call the parent class's updateQuantity directly. It will POST
      // to /cart/change.js a second time with `sections` requested.
      return CartItems.prototype.updateQuantity.call(
        this,
        line,
        quantity,
        event,
        name,
        variantId,
        callbackFn,
        lineKey,
      );
    }

    _didCrossFreeProductThreshold(oldTotal, newTotal) {
      const thresholdEl = document.querySelector("[data-treshold-product]");
      if (!thresholdEl) return false;
      const threshold = parseInt(thresholdEl.getAttribute("data-treshold-product"), 10) || 0;
      if (!threshold) return false;
      return (oldTotal < threshold) !== ((newTotal || 0) < threshold);
    }

    _refetchCartDrawerSection(state, eventTarget, event, variantId, callbackFn) {
      // Prefer section HTML bundled into the mutation response (requested via
      // the `sections` param when the transition was predictable) — that makes
      // this "refetch" free: zero extra network.
      const bundled = state && state.sections && state.sections["cart-drawer"];
      return (bundled ? Promise.resolve(bundled) : fetch(`${routes.cart_url}?section_id=cart-drawer`).then((r) => r.text()))
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, "text/html");
          const cartDrawerContainer = document.querySelector("cart-drawer");
          const newCartDrawer = html.querySelector("#CartDrawer");
          updateCartDrawer(cartDrawerContainer, newCartDrawer);
        })
        .then(() => {
          CartPerformance.measureFromEvent(`${eventTarget}:user-action`, event);
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: "cart-items",
            cartData: state,
            variantId: variantId,
          });
          if (typeof callbackFn === "function") callbackFn();
        })
        .catch((err) => {
          // Section refetch failed — server mutation already succeeded, but
          // we couldn't fetch the updated DOM. Revert optimistic paint and
          // surface the standard error message so the UI isn't stuck.
          console.error("CartDrawerItems _refetchCartDrawerSection failed:", err);
          this._revertOptimisticPaint();
          const errors =
            document.getElementById("cart-errors") || document.getElementById("CartDrawer-CartErrors");
          if (errors && window.cartStrings) errors.textContent = window.cartStrings.error;
        });
    }

    /**
     * Restore the DOM state that existed before _optimisticPaint mutated it.
     * Call after any error path so the drawer doesn't get stuck with a faded
     * row + zeroed count bubble while the line is still in the cart.
     */
    _revertOptimisticPaint(snapKey) {
      // Prefer the per-row snapshot when caller knows which row to revert.
      // Concurrent removes each push their own snapshot keyed by lineKey, so
      // reverting the latest single-slot `_lastOptimistic` would un-fade the
      // wrong row.
      let snap = null;
      if (snapKey && this._optimisticSnaps) {
        snap = this._optimisticSnaps.get(snapKey) || null;
        this._optimisticSnaps.delete(snapKey);
      }
      if (!snap) snap = this._lastOptimistic;
      if (!snap) return;

      const row = snap.lineKey
        ? this.querySelector(`tr.cart-item[data-key="${snap.lineKey}"]`)
        : document.getElementById(`CartDrawer-Item-${snap.line}`);
      if (row) {
        row.style.opacity = "";
        row.style.transition = "";
        const qtyInput = row.querySelector("input.quantity__input");
        if (qtyInput && snap.oldQty != null) qtyInput.value = String(snap.oldQty);
      }

      // Recompute count bubble + volume bar from current (restored) inputs.
      const variantQty = new Map();
      let totalCount = 0;
      this.querySelectorAll("tr.cart-item input.quantity__input").forEach((inp) => {
        // Hidden shipping-protection line never counts as a cart item.
        if (inp.closest("tr.cart-item[data-shipping-protection]")) return;
        const variant = inp.getAttribute("data-quantity-variant-id");
        const q = parseInt(inp.value, 10) || 0;
        if (variant) variantQty.set(variant, (variantQty.get(variant) || 0) + q);
        totalCount += q;
      });
      const bubbleNum = document.querySelector(".cart-count-bubble [aria-hidden='true']");
      if (bubbleNum) bubbleNum.textContent = totalCount < 100 ? String(totalCount) : "";
      document.querySelectorAll(".gb-cart-total-item").forEach((el) => {
        el.textContent = String(totalCount);
      });
      this._optimisticVolumeBars(variantQty);

      this._lastOptimistic = null;
    }

    /**
     * Synchronous DOM update fired on click, BEFORE the network roundtrip.
     * Only updates fields we can compute with certainty (no discount math):
     *   - the changed line's quantity input
     *   - count bubble (sum of all qty inputs)
     *   - volume discount bar (counts categorized items)
     * Authoritative line subtotals + cart total arrive in _applyJsonState().
     */
    _optimisticPaint(changedLine, newQuantity, lineKey) {
      // ── Quantity input + row hide for remove
      const row = lineKey
        ? this.querySelector(`tr.cart-item[data-key="${lineKey}"]`)
        : document.getElementById(`CartDrawer-Item-${changedLine}`);
      if (newQuantity === 0 && row) {
        // Hide visually; actual removal animation runs in _applyJsonState.
        row.style.transition = "opacity 0.15s ease-out";
        row.style.opacity = "0.4";
      } else if (row) {
        const qtyInput = row.querySelector("input.quantity__input");
        if (qtyInput && parseInt(qtyInput.value, 10) !== newQuantity) {
          qtyInput.value = newQuantity;
        }
      }

      // ── Sum all visible qty inputs for the count bubble + volume bar.
      // We read directly from inputs (excluding the row being removed)
      // because that's the authoritative client state right now.
      const variantQty = new Map();
      let totalCount = 0;
      const removedRowId = row ? row.id : null;
      this.querySelectorAll("tr.cart-item input.quantity__input").forEach((inp) => {
        const tr = inp.closest("tr.cart-item");
        // Hidden shipping-protection line never counts as a cart item.
        if (tr && tr.hasAttribute("data-shipping-protection")) return;
        // Skip the row we just visually removed.
        if (newQuantity === 0 && tr && removedRowId && tr.id === removedRowId) return;
        const variant = inp.getAttribute("data-quantity-variant-id");
        const q = parseInt(inp.value, 10) || 0;
        if (variant) variantQty.set(variant, (variantQty.get(variant) || 0) + q);
        totalCount += q;
      });

      // Count bubble.
      const bubbleNum = document.querySelector(".cart-count-bubble [aria-hidden='true']");
      if (bubbleNum) bubbleNum.textContent = totalCount < 100 ? String(totalCount) : "";
      document.querySelectorAll(".gb-cart-total-item").forEach((el) => {
        el.textContent = String(totalCount);
      });

      // ── Volume discount bar — recompute fills from variantQty.
      this._optimisticVolumeBars(variantQty);
    }

    /** Synchronous repaint of the volume bar using a Map<variant_id, qty>. */
    _optimisticVolumeBars(variantQty) {
      const configEl = document.getElementById("hcs-vdb-state");
      const bars = document.getElementById("hcs-volume-discount-bars");
      if (!configEl || !bars) return;
      let vdb;
      try {
        vdb = JSON.parse(configEl.textContent);
      } catch (e) {
        return;
      }
      const map = vdb.categorization || {};
      let bmsmCount = 0;
      let mmsCount = 0;
      variantQty.forEach((qty, variantId) => {
        const cat = map[String(variantId)];
        if (cat === "bmsm") bmsmCount += qty;
        else if (cat === "mms") mmsCount += qty;
      });
      if (vdb.config && vdb.config.frozen) this._paintBar(bars, "frozen", bmsmCount, vdb.config.frozen);
      if (vdb.config && vdb.config.pantry) this._paintBar(bars, "pantry", mmsCount, vdb.config.pantry);
    }

    /** Re-trigger a one-shot CSS animation class (no-op if el missing). */
    _pulse(el, cls) {
      if (!el) return;
      el.classList.remove(cls);
      void el.offsetWidth; // force reflow so the animation restarts
      el.classList.add(cls);
    }

    _formatMoney(cents) {
      if (window.Shopify && typeof Shopify.formatMoney === "function") {
        return Shopify.formatMoney(cents);
      }
      return `$${(cents / 100).toFixed(2)}`;
    }

    /**
     * Patch the cart-drawer DOM straight from cart/change.js JSON.
     * Updates: line qty inputs, line subtotals, cart total, count bubble,
     * checkout button label, savings line, volume discount bar, free-shipping
     * progress bar, shipping-protection card price.
     */
    _applyJsonState(state, changedLine, changedQuantity, changedLineKey) {
      const fm = this._formatMoney.bind(this);
      const cartStrings = window.cartStrings || {};

      // ── 1. If line was removed, fade out + remove its <tr>. Other lines'
      // line numbers DON'T renumber until the next section re-render — JS
      // walks state.items by index which can mismatch DOM line numbers after
      // a removal. To keep this simple and avoid renumbering bugs, we sync
      // remaining lines by matching state.items[i].variant_id against
      // [data-quantity-variant-id] on each row's qty input.
      //
      // Find the removed row by stable line-item key when caller provided
      // one. Falling back to the line-indexed id only works for the very
      // first remove; subsequent removes have shifted DOM ids by the time
      // we arrive here.
      if (changedQuantity === 0) {
        const row = changedLineKey
          ? this.querySelector(`tr.cart-item[data-key="${changedLineKey}"]`)
          : document.getElementById(`CartDrawer-Item-${changedLine}`);
        if (row) {
          row.style.transition = "opacity 0.2s ease-out, max-height 0.2s ease-out, margin 0.2s ease-out, padding 0.2s ease-out";
          row.style.maxHeight = `${row.offsetHeight}px`;
          requestAnimationFrame(() => {
            row.style.opacity = "0";
            row.style.maxHeight = "0";
            row.style.paddingTop = "0";
            row.style.paddingBottom = "0";
            row.style.marginTop = "0";
            row.style.marginBottom = "0";
          });
          setTimeout(() => row.remove(), 220);
        }
      }

      // ── 2. For each item still in cart, update its qty + line subtotal,
      // AND renumber the row's line-indexed attrs to match its new position
      // in state.items. Without this, a remove of line 1 leaves the remaining
      // row tagged data-index="2" — the next click sends line=2 to the server,
      // which returns 422 because that line no longer exists.
      state.items.forEach((item, i) => {
        const newLine = i + 1;
        // Prefer matching the row by stable line-item key. Two lines sharing
        // the same variant_id (different properties / selling plan) would
        // otherwise collide on the first match. Fall back to variant_id for
        // legacy DOM that hasn't picked up `data-key` yet.
        let row = item.key
          ? this.querySelector(`tr.cart-item[data-key="${item.key}"]`)
          : null;
        let qtyInput = row ? row.querySelector("input.quantity__input") : null;
        if (!qtyInput) {
          qtyInput = this.querySelector(
            `input.quantity__input[data-quantity-variant-id="${item.variant_id}"]`,
          );
          if (qtyInput) row = qtyInput.closest("tr.cart-item");
        }
        if (!qtyInput || !row) return;
        if (parseInt(qtyInput.value, 10) !== item.quantity) {
          qtyInput.value = item.quantity;
        }
        // data-cart-quantity is read by inventory checks elsewhere.
        qtyInput.setAttribute("data-cart-quantity", String(item.quantity));

        // Renumber line-indexed attrs. Liquid emits these as forloop.index
        // (1-based) — see snippets/cart-items.liquid.
        if (row.id !== `CartDrawer-Item-${newLine}`) row.id = `CartDrawer-Item-${newLine}`;
        if (qtyInput.id !== `Drawer-quantity-${newLine}`) qtyInput.id = `Drawer-quantity-${newLine}`;
        qtyInput.setAttribute("data-index", String(newLine));
        const removeBtn = row.querySelector("cart-remove-button");
        if (removeBtn) {
          removeBtn.setAttribute("data-index", String(newLine));
          if (removeBtn.id !== `CartDrawer-Remove-${newLine}`) removeBtn.id = `CartDrawer-Remove-${newLine}`;
        }

        // Visible price row — replicate cart-item-row.liquid's branches exactly
        // (including its unit-vs-line comparison quirk) so a later server render
        // never "corrects" what the fast path painted. Cart JSON lacks
        // variant.compare_at_price; the row carries it as data-hcs-compare-at
        // (unit cents, 0 when none).
        const caUnit = parseInt(row.dataset.hcsCompareAt, 10) || 0;
        const unitCents = parseInt(row.dataset.hcsUnitPrice, 10) || item.original_price;
        let compareCents = 0;
        if (caUnit > unitCents) {
          compareCents = caUnit * item.quantity;
        } else if (item.original_price !== item.final_line_price) {
          compareCents = item.original_price * item.quantity;
        }
        const currentPriceEl = row.querySelector(".hcs-ci__current-price");
        if (currentPriceEl) {
          currentPriceEl.textContent =
            item.final_line_price === 0 ? cartStrings.free || "Free" : fm(item.final_line_price);
        }
        // Toggle the strikethrough BOTH directions — crossing down a tier must
        // clear it, not leave the old compare price behind.
        const comparePriceEl = row.querySelector(".hcs-ci__compare-price");
        if (comparePriceEl) {
          if (compareCents > 0) {
            comparePriceEl.textContent = fm(compareCents);
            comparePriceEl.style.display = "";
          } else {
            comparePriceEl.style.display = "none";
          }
        }
        // Hidden legacy layout selectors (kept in DOM for any third-party code).
        const finalLegacy = row.querySelector(".cart-item__final-price");
        if (finalLegacy) {
          finalLegacy.textContent =
            item.final_line_price === 0 ? cartStrings.free || "Free" : fm(item.final_line_price);
        }
        const oldLegacy = row.querySelector(".cart-item__old-price");
        if (oldLegacy && item.original_line_price && item.original_line_price !== item.final_line_price) {
          oldLegacy.textContent = fm(item.original_line_price);
        }
      });

      // ── 3. Cart total: visible label + the hidden mirror used by JS metadata.
      const totalMoneyStr = fm(state.total_price);
      document.querySelectorAll(".cart-drawer .totals__total-value").forEach((el) => {
        el.textContent = totalMoneyStr;
      });
      document.querySelectorAll(".cart-drawer .gb-totals-total-value").forEach((el) => {
        el.textContent = String(state.total_price);
      });

      // ── 4. Checkout button label "Checkout · $X".
      const checkoutBtnText = document.querySelector("#CartDrawer-Checkout .button-text");
      if (checkoutBtnText) {
        const moneyOnly = fm(state.total_price);
        // Preserve any non-text decoration; replace just the trailing money.
        // Use a FUNCTION replacement, never a string: a money value like
        // "$120.00" starts with "$1", and in a string replacement "$1" is
        // parsed as a backreference to capture group 1 ("Checkout · "), which
        // duplicated the prefix -> "Checkout · Checkout · 20.00". A function
        // return value is treated literally, so "$" carries no special meaning.
        const labelRe = /(Checkout\s*(?:&middot;|·|•)\s*)([\s\S]+?)(\s*$)/;
        if (labelRe.test(checkoutBtnText.innerHTML)) {
          checkoutBtnText.innerHTML = checkoutBtnText.innerHTML.replace(
            labelRe,
            (_match, prefix, _oldMoney, trailing) => prefix + moneyOnly + trailing,
          );
        } else {
          checkoutBtnText.textContent = `Checkout · ${moneyOnly}`;
        }
      }

      // ── 5. Cart-icon count bubble. Shipping protection is a real cart line
      // but never a customer-facing "item", so it's excluded from the count.
      const visibleCount = this._visibleItemCount(state);
      const bubbleNum = document.querySelector(".cart-count-bubble [aria-hidden='true']");
      if (bubbleNum) {
        bubbleNum.textContent = visibleCount < 100 ? String(visibleCount) : "";
      }
      // Mirror for getCartMetadata().
      document.querySelectorAll(".gb-cart-total-item").forEach((el) => {
        el.textContent = String(visibleCount);
      });

      // ── 6. Savings line in footer — parity with cart-drawer.liquid's math:
      // Σ max(compare_at, variant.price) × qty − total_price. original_total_price
      // is NOT that (it ignores compare-at), which understated savings on the
      // fast path. Compare-at unit comes from each row's data-hcs-compare-at and
      // the variant unit price from data-hcs-unit-price; rows matched by
      // line-item key, falling back to item.original_price for legacy rows
      // without the attribute.
      let compareTotal = 0;
      state.items.forEach((item) => {
        const itemRow = item.key ? this.querySelector(`tr.cart-item[data-key="${item.key}"]`) : null;
        const rowCaUnit = itemRow ? parseInt(itemRow.dataset.hcsCompareAt, 10) || 0 : 0;
        const rowUnit = itemRow ? parseInt(itemRow.dataset.hcsUnitPrice, 10) || item.original_price : item.original_price;
        compareTotal += Math.max(rowCaUnit, rowUnit) * item.quantity;
      });
      const savings = compareTotal - (state.total_price || 0);
      const savingsEl = document.querySelector(".hcs-footer__savings");
      if (savingsEl) {
        if (savings > 0) {
          const savingsText = `Saving ${fm(savings)} on this order`;
          if (savingsEl.textContent.trim() !== savingsText) {
            savingsEl.textContent = savingsText;
            this._pulse(savingsEl, "hcs-footer__savings--pulse");
          }
          savingsEl.style.display = "";
        } else {
          savingsEl.style.display = "none";
        }
      }

      // ── 7. Volume discount bar — fully client-side from the cached map.
      this._updateVolumeBars(state);

      // ── 8. Free-shipping / free-product progress bar.
      this._updateFreeShippingBar(state);

      // ── 9. Shipping-protection card price (cart % clamped to min/max).
      this._updateShippingProtection(state);

      // Cart-empty toggles — JSON branch only handles the equal-state case
      // (wasEmpty === isNowEmpty), so these are mostly no-ops but cheap.
      const drawer = document.querySelector("cart-drawer");
      if (drawer) drawer.classList.toggle("is-empty", state.item_count === 0);
      this.classList.toggle("is-empty", state.item_count === 0);
    }

    /** Cart item count minus shipping-protection lines (hidden, not a product). */
    _visibleItemCount(state) {
      let count = state.item_count || 0;
      (state.items || []).forEach((it) => {
        if (it.handle === "shipping-protection") count -= it.quantity;
      });
      return count;
    }

    _updateVolumeBars(state) {
      const configEl = document.getElementById("hcs-vdb-state");
      const bars = document.getElementById("hcs-volume-discount-bars");
      if (!configEl || !bars) return;
      let vdb;
      try {
        vdb = JSON.parse(configEl.textContent);
      } catch (e) {
        return;
      }
      const map = vdb.categorization || {};
      let bmsmCount = 0;
      let mmsCount = 0;
      state.items.forEach((item) => {
        const cat = map[String(item.variant_id)];
        if (cat === "bmsm") bmsmCount += item.quantity;
        else if (cat === "mms") mmsCount += item.quantity;
      });

      if (vdb.config && vdb.config.frozen) {
        this._paintBar(bars, "frozen", bmsmCount, vdb.config.frozen);
      }
      if (vdb.config && vdb.config.pantry) {
        this._paintBar(bars, "pantry", mmsCount, vdb.config.pantry);
      }
    }

    _paintBar(rootEl, key, count, cfg) {
      // Identify the right program by emoji prefix in the label (frozen ❄ / pantry 🌶).
      const matchEmoji = key === "frozen" ? "❄" : "🌶";
      let program = null;
      rootEl.querySelectorAll(".hcs-vdb__program").forEach((p) => {
        const label = p.querySelector(".hcs-vdb__label")?.textContent ?? "";
        if (label.indexOf(matchEmoji) !== -1) program = p;
      });
      if (!program) return; // server didn't render a bar for this category

      const tiers = cfg.tiers || [];
      let currentTier = 0;
      let currentPct = 0;
      let currentFreeship = false;
      for (let i = tiers.length - 1; i >= 0; i--) {
        if (count >= tiers[i].count) {
          currentTier = i + 1;
          currentPct = tiers[i].pct;
          currentFreeship = !!tiers[i].freeship;
          break;
        }
      }

      // Badge ("20% off [+ FREE SHIP]")
      const badge = program.querySelector(".hcs-vdb__badge");
      if (badge) {
        if (currentPct > 0) {
          const newText = `${currentPct}% off${currentFreeship ? " + FREE SHIP" : ""}`;
          const badgeChanged = badge.textContent !== newText || badge.style.display === "none";
          badge.textContent = newText;
          badge.style.display = "";
          // Pop only on a real tier change so routine repaints don't re-animate.
          if (badgeChanged) this._pulse(badge, "hcs-vdb__badge--pop");
        } else {
          // Drop the pop class BEFORE hiding: it carries display:inline-block
          // !important (transforms need a box), which would beat the inline
          // display:none and keep a "hidden" badge visible.
          badge.classList.remove("hcs-vdb__badge--pop");
          badge.style.display = "none";
        }
      }

      // Segment fills.
      const segs = program.querySelectorAll(".hcs-vdb__segments .hcs-vdb__seg");
      segs.forEach((seg, i) => {
        const tier = tiers[i];
        if (!tier) return;
        const prevCount = i === 0 ? 0 : tiers[i - 1].count;
        const span = tier.count - prevCount;
        const filledHere = Math.max(0, count - prevCount);

        seg.classList.remove(`hcs-vdb__seg--${key}-on`, `hcs-vdb__seg--${key}-off`);
        let fillEl = seg.querySelector(`.hcs-vdb__seg-fill--${key}`);

        if (count >= tier.count) {
          seg.classList.add(`hcs-vdb__seg--${key}-on`);
          if (fillEl) fillEl.style.width = "0%";
        } else {
          seg.classList.add(`hcs-vdb__seg--${key}-off`);
          const pct = span > 0 ? Math.min(100, (filledHere / span) * 100) : 0;
          if (!fillEl) {
            fillEl = document.createElement("div");
            fillEl.className = `hcs-vdb__seg-fill--${key}`;
            fillEl.innerHTML = "&zwj;";
            seg.appendChild(fillEl);
          }
          fillEl.style.width = `${pct}%`;
        }
      });

      // Tier labels: bold/check the reached/current; mute the rest.
      const tierEls = program.querySelectorAll(".hcs-vdb__tiers .hcs-vdb__tier");
      const useShort = tierEls.length >= 4;
      // Read the customizer-set color off the badge so merchant overrides
      // survive client-side updates. Falls back to Liquid defaults.
      const badgeForColor = program.querySelector(`.hcs-vdb__badge--${key}`);
      const activeColor = badgeForColor
        ? getComputedStyle(badgeForColor).backgroundColor
        : key === "frozen"
          ? "#4A6B42"
          : "#9E7B4F";
      const mutedColor = "#999999";
      tierEls.forEach((el, i) => {
        const tier = tiers[i];
        if (!tier) return;
        const isReached = count >= tier.count;
        const isCurrent = currentTier === i + 1;
        const baseText = useShort ? `${tier.count} · ${tier.pct}%` : `${tier.count} items · ${tier.pct}%`;
        el.textContent = isCurrent ? `${baseText} ✓` : baseText;
        if (isReached) {
          el.style.setProperty("color", activeColor, "important");
          el.style.setProperty("font-weight", isCurrent ? "700" : "600", "important");
        } else {
          el.style.setProperty("color", mutedColor, "important");
          el.style.setProperty("font-weight", "600", "important");
        }
      });
    }

    _updateFreeShippingBar(state) {
      const progressbar = document.querySelector(".cart-drawer .free-product-progress-bar-main progress");
      if (!progressbar) return;
      const oldValue = parseInt(progressbar.value, 10) || 0;
      const target = state.total_price || 0;
      if (typeof animateProgressBar === "function") {
        animateProgressBar(progressbar, target, (window.TIMING && TIMING.PROGRESS_BAR_ANIMATION) || 1000);
      } else {
        progressbar.value = target;
      }
      if (typeof colorSVG === "function") {
        const container = document.querySelector("cart-drawer");
        if (container) colorSVG(container, oldValue, target);
      }
    }

    _updateShippingProtection(state) {
      const card = document.getElementById("hcs-sp-card");
      if (!card) return;
      const pct = parseFloat(card.dataset.spPct) || 4;
      const minCents = Math.round((parseFloat(card.dataset.spMin) || 1.99) * 100);
      const maxCents = Math.round((parseFloat(card.dataset.spMax) || 9.99) * 100);

      let spVariantIds = {};
      try {
        spVariantIds = JSON.parse(card.dataset.spVariants || "{}");
      } catch (e) {}
      const spVariantIdSet = new Set(Object.values(spVariantIds).map(String));

      let cartTotalCents = 0;
      state.items.forEach((it) => {
        if (spVariantIdSet.has(String(it.variant_id))) return;
        cartTotalCents += it.final_line_price;
      });

      let priceCents = Math.round((cartTotalCents * pct) / 100);
      priceCents = Math.max(minCents, Math.min(maxCents, priceCents));
      priceCents = Math.round((priceCents - minCents) / 10) * 10 + minCents;
      if (priceCents > maxCents) priceCents = maxCents;

      card.dataset.spCartTotal = String(cartTotalCents);
      card.dataset.spPrice = String(priceCents);
      const priceEl = document.getElementById("hcs-sp-price");
      if (priceEl) priceEl.textContent = this._formatMoney(priceCents);
    }
  }

  customElements.define("cart-drawer-items", CartDrawerItems);
}

/* ── Mobile background-scroll lock ──────────────────────────────────────────
   body.cart-drawer-open is toggled in open()/close(). While the drawer is open,
   block touch scrolling UNLESS the touch is inside a genuinely scrollable region
   of the drawer (the cart items list, or the horizontal upsell carousel).
   overflow:hidden on <body> does NOT stop touch scrolling on iOS, so without
   this the page behind the drawer scrolls and the drawer "peeks". Gated on the
   class, so it is a no-op when the drawer is closed and can never freeze the
   page. passive:false is required to allow preventDefault. */
(function () {
  function isScrollable(el) {
    if (!el || el.nodeType !== 1) return false;
    var s = getComputedStyle(el);
    var y = (s.overflowY === 'auto' || s.overflowY === 'scroll') && el.scrollHeight > el.clientHeight + 1;
    var x = (s.overflowX === 'auto' || s.overflowX === 'scroll') && el.scrollWidth > el.clientWidth + 1;
    return x || y;
  }
  document.addEventListener('touchmove', function (e) {
    if (!document.body.classList.contains('cart-drawer-open')) return;
    if (e.touches && e.touches.length > 1) return; /* leave pinch-zoom alone */
    var node = e.target;
    while (node && node !== document.body && node.nodeType === 1) {
      if (isScrollable(node)) return; /* let this drawer region scroll natively */
      node = node.parentNode;
    }
    e.preventDefault(); /* nothing scrollable under the touch → no page scroll */
  }, { passive: false });
})();

window.CartDrawer = CartDrawer;
})();
